export default [{
  path: '/profile',
  name: 'myprofile',
  component: () => import('@/app/user-profile/UserProfile'),
  meta: {
    resource: 'profile',
    actions: ['read']
  }
}]
